import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_GET_SURVEYS_CAMPAIGNS_ID_REMINDER_EMPLOYEES,
  KEY_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES,
} from '../constats';
import { MOCK_RESPONSE_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES } from '../mocks';

type RequestPostSurveysCampaignByIdReminderEmployees = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY
>['request']['path'];

type ResponsePostSurveysCampaignByIdReminderEmployees = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY
>['response']['body'];

type CallParamsPostSurveysCampaignByIdReminderEmployees = Omit<
  RequestPostSurveysCampaignByIdReminderEmployees,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostSurveysCampaignByIdReminderEmployees =
  ResponsePostSurveysCampaignByIdReminderEmployees;

type CallErrorPostSurveysCampaignByIdReminderEmployees = GenericApiError;

type CallSelectorsPostSurveysCampaignByIdReminderEmployees = unknown;

export const getSurveysCampaignByIdReminderEmployeesCall = createGeneralCall<
  CallParamsPostSurveysCampaignByIdReminderEmployees,
  CallResponsePostSurveysCampaignByIdReminderEmployees,
  CallErrorPostSurveysCampaignByIdReminderEmployees,
  CallSelectorsPostSurveysCampaignByIdReminderEmployees
>({
  id: KEY_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_SURVEYS_CAMPAIGNS_ID_REMINDER_EMPLOYEES(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES
    : undefined,
});
